module.exports = __webpack_public_path__ + "img/sely.1f893aff.png";